export default __webpack_public_path__ + "static/media/img-0194-columbia-full-face.ed9db371.png";